<template>
  <div class="pay-pane">
    <div class="header-tip">
      <i class="iconfont iconzhifu"></i>
      <span :style="{ fontWeight: 500 }">支付</span>
    </div>
    <div class="case-total">
      <slot></slot>
    </div>
    <div class="container">
      <div class="qrcode-content">
        <div id="qrcode" class="qrcode"></div>
      </div>
      <div class="order-content">
        <div class="order-item">
          <i class="iconfont iconweixin"></i>
          <span class="title">微信扫码支付</span>
        </div>
        <template v-if="orderInfo">
          <div class="order-item">
            <span class="title">应付金额：</span>
            <span class="price">
              <span>￥</span>
              <span class="price-bold">{{ orderInfo.realPrice }}</span>
            </span>
          </div>
          <div class="order-item">
            <span class="title">到期时间：</span>
            <span>{{ (now + productDetail.expirationTimeDelta) | dateFilter }}</span>
          </div>
          <div class="order-item">
            <span class="title">创建时间：</span>
            <span>{{ now | dateFilter }}</span>
          </div>
          <div class="order-item desc">
            <span>支付之后如需开发票请联系客服</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { services } from '@/service';

export default {
  data() {
    return {
      qrcode: '',
      now: Date.now(),
      orderId: '',
      payTimeOut: 0,
      orderInfo: null
    };
  },
  props: {
    productDetail: {
      type: Object,
      required: true
    }
  },
  beforeDestroy() {
    if (this.payTimeOut) {
      clearTimeout(this.payTimeOut);
    }
  },
  async mounted() {
    try {
      const { orderInfo, unifiedOrder } = await services.authriozation.getPayOrderCode({
        productId: this.productDetail.id,
        body: '小包公-' + this.productDetail.label
      });
      new QRCode('qrcode', {
        width: 160, // 二维码宽度，单位像素
        height: 160, // 二维码高度，单位像素
        text: unifiedOrder.codeUrl // 生成二维码的链接
      });
      this.orderId = unifiedOrder.orderId;
      this.orderInfo = orderInfo;
      this.getOrderStatus();
    } catch (err) {
      this.$error(err);
    }
  },
  methods: {
    paySuccessHandle() {
      clearTimeout(this.payTimeOut);
      this.$emit('paySuccess', this.orderId);
    },
    async getOrderStatus() {
      try {
        const res = await services.authriozation.getOrderDetail(this.orderId);
        if (res.status == 'SUCCESS') {
          this.$message({ message: '支付成功', type: 'success' });
          this.paySuccessHandle();
        } else {
          this.payTimeOut = setTimeout(() => {
            this.getOrderStatus();
          }, 2000);
        }
      } catch (err) {
        this.$error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-pane {
  padding: 80px 110px;

  .header-tip {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #2c3443;
    .iconfont {
      font-size: 28px;
      color: #04c838;
      margin-right: 10px;
    }
  }
  .case-total {
    color: #3d465a;
    font-size: 16px;
    line-height: 22px;
    margin-top: 20px;
  }

  .container {
    display: flex;
    margin-top: 50px;

    .qrcode-content {
      box-sizing: border-box;
      width: 180px;
      height: 180px;
      border: 1px solid #d2d8e3;
      padding: 10px;
    }

    .order-content {
      flex: 1;
      width: 0;
      font-size: 14px;
      color: #2c3443;
      margin-left: 30px;

      .order-item {
        margin-top: 20px;

        .title {
          color: #3d465a;
        }

        &:first-child {
          margin-top: 0;
        }

        &.desc {
          font-size: 12px;
          color: #77839e;
        }

        .iconweixin {
          font-size: 18px;
          color: #04c838;
          margin-right: 10px;
        }

        .price {
          font-size: 20px;
          color: #f62733;
          .price-bold {
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
